/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API50849Req {
  
  /** 任务id */
  taskId?: number;
  /** 任务转交人用户id */
  taskTransferId?: string;
};



export interface API50849Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 50849 转交执行人

export interface IUsePostAPI50849Return {
  /** 转交执行人: 接口请求状态 */
  isAPI50849Loading: boolean;
  /** 转交执行人: 接口请求返回数据 */
  dataAPI50849: API50849Res;
  /**  转交执行人: 接口数据请求方法 */
  fetchAPI50849Data:  (inputs: API50849Req, config?: YWRequestConfig) => Promise<API50849Res>;
  /** 转交执行人: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI50849 = ():IUsePostAPI50849Return => {
  let isMount = true;
  const [isAPI50849Loading, setIsAPI50849Loading] = useState(false);
  const [dataAPI50849, setDataAPI50849] = useState<API50849Res>({} as API50849Res);
  const requestUrl = `${basePath}/team-work/workTask/transferExecutor`;

  const fetchAPI50849Data = async (inputs: API50849Req, config?: YWRequestConfig): Promise<API50849Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50849Req>) || {}) as API50849Req;
    
  
    if ( isMount ) {
      setIsAPI50849Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API50849Res>(`${basePath}/team-work/workTask/transferExecutor`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI50849(res || {} as API50849Res);
        setIsAPI50849Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50849Loading(false);
      }
      return false as unknown as API50849Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50849Loading,
    dataAPI50849,
    fetchAPI50849Data,
    requestUrl,
  }
}

